import { all } from 'redux-saga/effects';

import { purchasePhoneNumbersSaga } from './twilio.action';

export { clearAvailablePhoneNumbers, purchasePhoneNumbers } from './twilio.action';

export const twilioSaga = function* () {
  yield all([purchasePhoneNumbersSaga()]);
};

export { default as twilioReducer } from './twilio.reducer';
